import script from "./ReportesGymView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportesGymView.vue?vue&type=script&setup=true&lang=js"

import "./ReportesGymView.vue?vue&type=style&index=0&id=1707aa5d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1707aa5d"]])

export default __exports__